const localeCodes = {
		de: 'de-DE',
		en: 'en-US',
		es: 'es-419',
		fr: 'fr-FR',
		it: 'it-IT',
		nl: 'nl-NL',
		pl: 'pl-PL',
		pt: 'pt-BR',
		th: 'th-TH',
		tr: 'tr-TR',
		zh: 'zh-TW',
	},
	locales = Object.values(localeCodes);

export { locales, localeCodes };



// WEBPACK FOOTER //
// ./src/config/locales.js